import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=42a5c569&"
import script from "./AppTabs.vue?vue&type=script&lang=ts&"
export * from "./AppTabs.vue?vue&type=script&lang=ts&"
import style0 from "./AppTabs.vue?vue&type=style&index=0&id=42a5c569&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports